import { gql } from "@apollo/client";

const DisableProjectMutation = gql`
  mutation ProjectDisable($projectName: String!) {
    disableProject(input: { tprojectName: $projectName }) {
      clientMutationId
    }
  }
`;

const EnableProjectMutation = gql`
  mutation ProjectEnable($projectName: String!) {
    enableProject(input: { tprojectName: $projectName }) {
      clientMutationId
    }
  }
`;

const hash = "048025a7bfff9fbbbaba147d5420b386c379c97a9c78d5be35ba23cd897a97d3";
const hash2 =
  "a496d9e184185554ff5f8ae35622b6577efeffb1f3a99d2a511a911e752d672d";

export { EnableProjectMutation, DisableProjectMutation, hash, hash2 };
